define(["require", "exports"], function (require, exports) {
    "use strict";
    var stringUtils = /** @class */ (function () {
        function stringUtils() {
        }
        stringUtils.endsWith = function (source, suffix) {
            return source.indexOf(suffix, source.length - suffix.length) !== -1;
        };
        stringUtils.contains = function (source, search) {
            if (!source) {
                return false;
            }
            return source.indexOf(search) !== -1;
        };
        stringUtils.pad = function (n, deep) {
            if (deep === void 0) { deep = 1; }
            if (deep == 1) {
                return (n < 10) ? ('0' + n) : n + '';
            }
            if (deep == 2) {
                return (n < 100) && (n >= 10) ? ('0' + n) : (n < 10) ? ('00' + n) : n + '';
                ;
            }
            return (n < 10) ? ('0' + n) : n + '';
        };
        stringUtils.formatNumber = function (number) {
            var str = number.replace("+1", "").replace("+", "");
            return str.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        };
        stringUtils.formatMacAddress = function (macAddress) {
            if (macAddress) {
                var deviceMac = macAddress.toUpperCase();
                if (deviceMac.length >= 3 && deviceMac.length <= 16) {
                    deviceMac = deviceMac.replace(/\W/ig, '');
                    // deviceMac = deviceMac.replace(/(.{2})/g, "$1:");
                    deviceMac = deviceMac
                        .match(/.{1,2}/g).join(':');
                }
                return deviceMac;
            }
            return macAddress || '';
        };
        stringUtils.formatMacAddresses = function (userInput, splitter) {
            var macAddresses = userInput || null;
            if (macAddresses) {
                var addresses = macAddresses.split(' ');
                var formattedAddresses = [];
                for (var _i = 0, addresses_1 = addresses; _i < addresses_1.length; _i++) {
                    var address = addresses_1[_i];
                    formattedAddresses.push(stringUtils.formatMacAddress(address));
                }
                return formattedAddresses.join(splitter);
            }
            return userInput || '';
        };
        return stringUtils;
    }());
    (window['global'] || (window['global'] = {})).stringUtils = stringUtils;
    return stringUtils;
});
//# sourceMappingURL=stringUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/stringUtils.js
// module id = 81
// module chunks = 2